import useEventContext from '@hooks/useEventContext';
import PaymentsTable from '@molecules/PaymentsTable';
import { CircularProgress, Typography } from '@mui/material';

// manage event payment
export default function EventPaymentHistory() {
    // edit payment admins
    // view payment reporting
    // view failed payments
    // view successful payments?
    // link to stripe dashboard

    const { loading, stripePaymentUser } = useEventContext();

    // Show loading before trying to load the stripe Connect instance
    if (loading) {
        return (
            <div style={{ textAlign: 'center', padding: '5rem' }}>
                <CircularProgress />
            </div>
        );
    }

    if (!stripePaymentUser?.stripeId) {
        return <Typography>Stipe account loading or not connected successfully</Typography>;
    }

    return (
        <div>
            <PaymentsTable connectedAccountId={stripePaymentUser?.stripeId || ''} />
        </div>
    );
}
